import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { evp } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F07c_SplitPaymentToEvpManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={evp}
  />
);

export default Sim_F07c_SplitPaymentToEvpManually;
